export function StatusPill({ status }) {
  // Cores theme-aware vindas das CSS vars (definidas em globals.css)
  const map = {
    'Solicitada': { bg: 'var(--pill-blue-bg)',   fg: 'var(--pill-blue-fg)',   line: 'var(--pill-blue-line)' },
    // Aprovada usa o mesmo verde de Recebido — sinaliza 'OK do tomador'
    // antes da emissao. Distingue de Enviada (NF ja saiu), Aguardando
    // pagamento (cliente confirmou o recebimento da NF) e Recebido
    // (pagamento confirmado pela nossa equipe).
    'Aprovada':   { bg: 'var(--pill-green-bg)',  fg: 'var(--pill-green-fg)',  line: 'var(--pill-green-line)' },
    'Enviada':    { bg: 'var(--pill-yellow-bg)', fg: 'var(--pill-yellow-fg)', line: 'var(--pill-yellow-line)' },
    // Cliente confirmou o recebimento da NF via CTA do email; falta so o
    // dinheiro cair. Purple soft pra destacar do amarelo do Enviada e do
    // verde do Recebido.
    'Aguardando pagamento': { bg: 'var(--pill-purple-bg)', fg: 'var(--pill-purple-fg)', line: 'var(--pill-purple-line)' },
    'Recebido':   { bg: 'var(--pill-green-bg)',  fg: 'var(--pill-green-fg)',  line: 'var(--pill-green-line)' },
    'Atrasado':   { bg: 'var(--pill-orange-bg)', fg: 'var(--pill-orange-fg)', line: 'var(--pill-orange-line)' },
    'Cancelada':  { bg: 'var(--pill-red-bg)',    fg: 'var(--pill-red-fg)',    line: 'var(--pill-red-line)' },
  };
  const c = map[status] || map['Solicitada'];
  return (
    <span className="chip" style={{ background: c.bg, color: c.fg, borderColor: c.line }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: c.fg }} />
      {status}
    </span>
  );
}
